import React, { useState, useEffect } from "react";
import { Button, Radio, Form, Table, Tag, Drawer, Select, Input, message } from "antd";
import { Panel } from "primereact/panel";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Server from "../Server.js";
import { connect } from "react-redux";
import { getContainer } from "rsuite/esm/DOMHelper";
const { TextArea } = Input;

function PakeList(props) {
  const [dataSource, setDataSource] = useState([]);
  const [status, setStatus] = useState("0");
  const [selectedId, setSelectedId] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const [open, setOpen] = useState(false);

  const options = [
    { label: "درخواست شده", value: "0" },
    { label: "بررسی شده - در جریان", value: "1" },
    { label: "اتمام عملیات", value: "2" },
    { label: "لغو شده", value: "3" },
    { label: "همه", value: "all" },
  ];
  const [form] = Form.useForm();
  const columns = [
    {
      title: "نوع",
      dataIndex: "type",
      width: 300,
      key: "type",
    },
    {
      title: "آدرس",
      dataIndex: "address",
      width: 300,
      key: "address",
    },
    {
      title: "موبایل",
      dataIndex: "mobile",
      width: 300,
      key: "mobile",
    },
    {
      title: "تاریخ درخواست",
      dataIndex: "reqDate",
      width: 300,
      key: "reqDate",
    },
    {
      title: "وضعیت",
      width: 300,
      dataIndex: "status",
      key: "status",
      render: (_, record) =>
        record.status == "2" ? (
          <Tag color={"green"}>اتمام عملیات</Tag>
        ) : record.status == "1" ? (
          <Tag color={"blue"}>بررسی شده - در جریان</Tag>
        ) : record.status == "0" ? (
          <Tag color={"gold"}>درخواست شده</Tag>
        ) : (
          <Tag color={"red"}>لغو شده</Tag>
        ),
    },
  ];
  useEffect(() => {
    getPaykList();
  }, []);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const getPaykList = (param) => {
    let s = param || status;
    debugger;
    s = s == "all" ? ["0", "1", "2", "-1"] : [s];
    new Server().send(
      "CompanyApi/getpakelist",
      {
        systemId: props.systemId,
        status: s,
      },
      function (response) {
        setDataSource(response.data.result);
      },
      function (error) {
        console.log(error);
      }
    );
  };

  
  const onFinish = (values) => {
    console.log(values);
    debugger;
    values.status = values.status.key
    new Server().send("CompanyApi/updatePaykStatus",
      {
        systemId: props.systemId,
        _id: selectedId,
        params: values,
      },
      function (response) {
       setOpen(false);
       getPaykList();     
        messageApi.success("عملیات با موفقیت انجام شد");
      },
      function (error) {
        messageApi.error("عملیات انجام نشد");
        console.log(error);
      }
    );
  };

  /*
  const submit = (value) => {
    console.log(props);
    new Server().send(
      selectedId
        ? "AdminApi/UpdateProductCategory"
        : "AdminApi/InsertProductCategory",
      {
        systemId: props.systemId,
        name: value.name,
        desc: value.desc,
        img: value.img,
        extraFields: extra ? value.extraFields : [],
        _id: selectedId,
      },
      function (response) {
        messageApi.info("عملیات با موفقیت انجام شد");
        getCats();
      },
      function (error) {
        messageApi.error("عملیات انجام نشد");
        console.log(error);
      }
    );
  };
  */
  return (
    <>
     {contextHolder}
      <div style={{ direction: "rtl" }}>
        <div className="row justify-content-right mt-2">
          <div className="col-12" style={{ background: "#fff" }}>
            <Panel
              header="درخواست های پیک جاری"
              style={{
                textAlign: "right",
                marginBottom: 50,
                fontFamily: "yekan",
              }}
            >
              <Radio.Group
                options={options}
                onChange={({ target: { value } }) => {
                  setStatus(value);
                  getPaykList(value);
                }}
                value={status}
                optionType="button"
                buttonStyle="solid"
              />

              <p style={{ display: "flex", justifyContent: "right" }}>
               
              </p>
              <Table
                dataSource={dataSource}
                columns={columns}
                sticky={true}
                className="iranyekanwebregular"
                onRow={(record, rowIndex) => ({
                  onClick: () => {
                    console.log("Row onclick");
                    debugger;
                    setSelectedId(record._id)
                    setOpen(true)
                    form.setFieldsValue({
                        status: record.status,
                        mobile: record.mobile,
                        address: record.address,
                        type: record.type,
                      });
                    /*setSelectedId(record._id);
                    setExtra(record.extraFields && record.extraFields.length > 0)
                    form.setFieldsValue({
                      name: record.name,
                      desc: record.desc,
                      extraFields: record.extraFields
                    });
                    setFileList([
                      {
                        uid: "-1",
                        name: "image.png",
                        status: "done",
                        url: record.imgUrl,
                        response: record.originalImg,
                      },
                    ]);*/
                  },
                })}
              />

              <Drawer
                title="ویرایش وضعیت "
                open={open}
                onClose={()=> onClose()}
                style={{minWidth:400,maxWidth:'100%'}}
              >
                <Form
                  name="basic"
                  style={{
                    maxWidth: 600,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={() => {}}
                  autoComplete="off"
                  form={form}
                >
                     <Form.Item
                      name="mobile"
                      label={
                        <div style={{ width: "100%", textAlign: "right",width:100 }}>
                          تلفن همراه
                        </div>
                      }
                      style={{ width: "100%" }}
                    >
                      <Input style={{ textAlign: "right", width: "100%" }} />
                    </Form.Item>
                    <Form.Item
                      name="address"
                      label={
                        <div style={{ width: "100%", textAlign: "right",width:100 }}>
                          آدرس
                        </div>
                      }
                      style={{ width: "100%" }}
                    >
                      <TextArea
                        autoSize={{
                        minRows: 2,
                        maxRows: 6,
                        }}
                        style={{ textAlign: "right", width: "100%" }} 
                    />
                    </Form.Item>
                    <Form.Item
                      name="type"
                      label={
                        <div style={{ width: "100%", textAlign: "right",width:100 }}>
                         نوع
                        </div>
                      }
                      style={{ width: "100%" }}
                    >
                      <Select
                        labelInValue = {true}
                        
                        style={{
                            width: "100%",
                        }}
                        options={[{
                            label: "ارسال چک به صندوق",
                            value: "ارسال چک به صندوق"
                        },{
                            label: "دریافت چک برگشتی",
                            value: "دریافت چک برگشتی"
                        }]}
                        />
                    </Form.Item>
              <Form.Item
                name="status"
                label={
                    <div style={{ width: "100%", textAlign: "right",width:100 }}>
                     وضعیت
                    </div>
                  }
                  style={{ width: "100%" }}
                >
                <Select
                    labelInValue = {true}
                    style={{
                        width: "100%",
                    }}
                    options={options}
                    />
                </Form.Item>
                  <Form.Item
                    style={{ display: "flex", justifyContent: "right",width:100 }}
                  >
                    <Button
                      type="primary"
                      htmlType="submit"
                      style={{ marginTop: 20 }}
                      onClick={() => {
                        // payment()
                      }}
                    >
                     ذخیره تغییرات
                    </Button>
                  </Form.Item>
                </Form>
              </Drawer>
            </Panel>
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(PakeList);
